module.exports = __webpack_public_path__ + "img/2.c7a365db.png";